import React, { Component } from 'react'
import { Popup } from 'devextreme-react/popup'
import Form from 'devextreme-react/form'
import { banks, rekBankByProductId } from 'dataSource/lookup'
import { FileUploader } from 'devextreme-react'
import ModalPreviewPdf from 'components/pages/modal/previewPdf'
import { formatUploadFileData } from 'plugin/helper'
import { imageSource } from 'plugin/helper'
import { showLoading } from 'redux/actions/loading'
import notify from 'devextreme/ui/notify'
import httpRequest from 'plugin/httprequest'

class FormPembayaranTagihan extends Component {
  constructor(props) {
    super(props)

    this.state = {
      popupVisible: false,
      dataMaster: {},
      dataParent: {},
      DataDocument: {},
      uploadedData: [],
    }

    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)

    this.PopupRef = React.createRef()
    this.formPembayaranTagihanParentRef = React.createRef()
    this.modalPreviewPdfRef = React.createRef()
    this.fileUploderRef = React.createRef()

    this.class =
      this.props.type === 'add'
        ? 'bd-input-popup-dapen-default'
        : 'bd-input-popup-disabled-dapen-default'

    this.formItems = [
      {
        dataField: 'payDate',
        label: {
          text: 'Tanggal Pembayaran',
        },
        editorType: 'dxDateBox',
        editorOptions: {
          elementAttr: { class: this.class },
          displayFormat: 'dd MMM yyyy',
          useMaskBehavior: true,
          width: '100%',
          openOnFieldClick: true,
          placeholder: 'Tanggal Pembayaran',
        },
      },
      {
        dataField: 'sourceRekNo',
        label: {
          text: 'Dari Rekening Giro',
        },
        editorOptions: {
          elementAttr: { class: this.class },
          placeholder: 'Silahkan isi rekening giro',
        },
      },
      {
        dataField: 'sourceBankId',
        label: {
          text: 'Dari Bank Giro',
        },
        editorType: 'dxSelectBox',
        editorOptions: {
          dataSource: banks(this.props.store),
          valueExpr: 'id',
          displayExpr: 'bankName',
          elementAttr: { class: this.class },
          searchEnabled: true,
          deferRendering: false,
          placeholder: 'Silahkan pilih bank giro',
        },
      },
      {
        dataField: 'payAmount',
        label: {
          text: 'Jumlah Pembayaran',
        },
        editorType: 'dxNumberBox',
        editorOptions: {
          elementAttr: { class: this.class },
          format: '#,##0.00',
        },
      },
      {
        dataField: 'payRekNo',
        label: {
          text: 'Rekening Tujuan',
        },
        editorType: 'dxSelectBox',
        editorOptions: {
          elementAttr: { class: this.class },
          dataSource: [],
          valueExpr: 'rekNo',
          displayExpr: (item) => {
            return item && item.rekNo + ' - ' + item.rekName
          },
          searchEnabled: true,
          deferRendering: false,
          placeholder: 'Silahkan isi rekening giro',
          onValueChanged: async (e) => {
            if (e.value) {
              let payBankId = await httpRequest(
                process.env.REACT_APP_BACKEND_CORE,
                this.props.store,
                `rekbanks/rek-no/${e.value}`
              )
              this.formPembayaranTagihanParentRef.current.instance
                .getEditor('payBankId')
                .option('value', payBankId.bankId)
            }
          },
        },
      },
      {
        dataField: 'payBankId',
        label: {
          text: 'Bank Tujuan',
        },
        editorType: 'dxSelectBox',
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
          dataSource: banks(this.props.store),
          valueExpr: 'id',
          displayExpr: 'bankName',
          searchEnabled: true,
          deferRendering: false,
          readOnly: true,
          placeholder: 'Silahkan pilih bank giro',
        },
      },
    ]

    this.PopupToolbarItem = [
      {
        widget: 'dxButton',
        location: 'after',
        options: {
          text: 'Simpan',
          elementAttr: { class: 'bg-button-popup-save-dapen-default' },
          onClick: this.submitData.bind(this),
        },
        toolbar: 'bottom',
      },
      {
        widget: 'dxButton',
        location: 'after',
        options: {
          text: 'Batal',
          elementAttr: { class: 'bg-button-popup-close-dapen-default' },
          onClick: this.hide.bind(this),
        },
        toolbar: 'bottom',
      },
    ]

    this.PopupToolbarItem2 = [
      {
        widget: 'dxButton',
        location: 'after',
        options: {
          text: 'Batal',
          elementAttr: { class: 'bg-button-popup-close-dapen-default' },
          onClick: this.hide.bind(this),
        },
        toolbar: 'bottom',
      },
    ]
  }

  get Popup() {
    return this.PopupRef.current.instance
  }

  onUploadStarted = (e) => {
    var fieldName = e.component._options._optionManager._options.name
    for (var i = 0; i < e.value.length; i++) {
      var files = e.value[i]

      var fr = new FileReader()

      var formattedFileData

      var DataDocument = { ...this.state.DataDocument }

      fr.onload = (efr) => {
        formattedFileData = formatUploadFileData(efr.target.result)

        DataDocument[`${fieldName}Name`] = files.name
        DataDocument[`${fieldName}File`] = formattedFileData.base64data
        DataDocument[`${fieldName}FileContentType`] = formattedFileData.mime

        this.setState({
          DataDocument: DataDocument,
        })
      }

      fr.readAsDataURL(files)
    }
  }

  previewFile = async (state, fileName) => {
    var src = imageSource(
      state[`${fileName}FileContentType`],
      state[`${fileName}File`]
    )
    this.modalPreviewPdfRef.current.show()
    this.modalPreviewPdfRef.current.retrieveData(src)
  }

  show() {
    this.setState({
      popupVisible: true,
    })
  }

  retrieveData = async (data, pembayaranId) => {
    let getPembayaran
    let getDokumen
    if (pembayaranId) {
      getPembayaran = await httpRequest(
        process.env.REACT_APP_BACKEND_CORE,
        this.props.store,
        `participant-payments/${pembayaranId}`
      )
      getDokumen = {
        dokumenFile: getPembayaran.file,
        dokumenFileContentType: getPembayaran.fileContentType,
        dokumenName: getPembayaran.fileName,
      }
    } else {
      getPembayaran = {}
      getDokumen = {}
    }
    this.setState({
      dataParent: data,
      dataMaster: getPembayaran,
      DataDocument: getDokumen,
    })

    this.formPembayaranTagihanParentRef.current.instance
      .getEditor('payRekNo')
      .option(
        'dataSource',
        rekBankByProductId(this.props.store, data.productId)
      )
  }

  hide = async (e) => {
    this.setState({
      popupVisible: false,
      dataMaster: {},
      dataParent: {},
      DataDocument: {},
    })
  }

  submitData = async () => {
    this.props.store.dispatch(showLoading(true))
    const dataParent = this.state.dataParent
    const dataMaster = this.state.dataMaster
    const filePembayaran = this.state.DataDocument
    const jsonReqs = {
      file: filePembayaran.dokumenFile,
      fileContentType: filePembayaran.dokumenFileContentType,
      fileName: filePembayaran.dokumenName,
      invoiceId: dataParent.id,
      participantId: dataParent.participantId,
      payAmount: dataMaster.payAmount,
      payBankId: dataMaster.payBankId,
      payDate: dataMaster.payDate,
      payRekNo: dataMaster.payRekNo,
      sourceBankId: dataMaster.sourceBankId,
      sourceRekNo: dataMaster.sourceRekNo,
    }
    let api = `wp/pembayaran-tagihans`
    try {
      await httpRequest(
        process.env.REACT_APP_BACKEND_CORE,
        this.props.store,
        api,
        'POST',
        {
          values: jsonReqs,
        }
      )
      this.hide()
      this.props.store.dispatch(showLoading(false))
      notify(
        {
          message: 'Berhasil Simpan Data !',
          width: 'AUTO',
          shading: true,
          position: { at: 'center', my: 'center', of: window },
        },
        'success',
        1000
      )
      await this.props.forceRefresh()
    } catch (error) {
      console.error(error)
      this.props.store.dispatch(showLoading(false))
      notify(
        {
          message: 'Gagal Menyimpan Data !',
          width: 'AUTO',
          shading: true,
          position: { at: 'center', my: 'center', of: window },
        },
        'error',
        1000
      )
    }
  }

  render() {
    return (
      <React.Fragment>
        <Popup
          className={'popup'}
          visible={this.state.popupVisible}
          onHiding={this.hide}
          dragEnabled={true}
          showTitle={true}
          title={`Pembayaran Tagihan`}
          width={'550px'}
          height="auto"
          ref={this.PopupRef}
          toolbarItems={
            this.props.type === 'add'
              ? this.PopupToolbarItem
              : this.PopupToolbarItem2
          }
        >
          <Form
            ref={this.formPembayaranTagihanParentRef}
            colCount={1}
            id={'formPembayaranTagihanParent'}
            formData={this.state.dataMaster}
            items={this.formItems}
            labelLocation="left"
            readOnly={this.props.type === 'add' ? false : true}
          />
          <div className="row">
            <div className="col-md-12">
              <FileUploader
                accept={'.png,.jpg,.jpeg,.gif,.bmp,application/pdf'}
                uploadMode={'useForm'}
                onValueChanged={this.onUploadStarted.bind(this)}
                labelText={
                  this.state.DataDocument.dokumenName ||
                  'Silahkan upload bukti pembayaran'
                }
                showFileList={false}
                name={'dokumen'}
                value={this.state.uploadedData}
                ref={this.fileUploderRef}
              />
            </div>
            <div className="col-md-12 text-left my-auto ml-2">
              <button
                onClick={() =>
                  this.previewFile(this.state.DataDocument, 'dokumen')
                }
                className={`btn btn-light btn-sm bg-button-popup-save-dapen-default mr-3 ${
                  this.state.DataDocument.dokumenName ? '' : 'd-none'
                }`}
                style={{ width: '122px' }}
              >
                Preview
              </button>
            </div>
            <ModalPreviewPdf
              ref={this.modalPreviewPdfRef}
              store={this.props.store}
            />
          </div>
        </Popup>
      </React.Fragment>
    )
  }
}

export default FormPembayaranTagihan
